import useChatsUnreadSummaryQuery from "./useChatsUnreadSummaryQuery";

// Number of chats with at least one unread message — drives the tab/profile
// badge. For per-message totals inside a single chat use useOrderChatUnreadCount.

type UseChatsUnreadCountProps = {
  customerId: number | undefined;
  isOrderChatEnabled: boolean;
};

const useChatsUnreadCount = ({ customerId, isOrderChatEnabled }: UseChatsUnreadCountProps): number => {
  const { data } = useChatsUnreadSummaryQuery(customerId, { enabled: !!customerId && isOrderChatEnabled });
  return (data?.items ?? []).filter((item) => item.unreadCount > 0).length;
};

export default useChatsUnreadCount;
